var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 598 415",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 172.94L373.74 216.07L299.04 172.94L373.74 129.81L448.44 172.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 216.07L448.44 172.94L523.14 216.07L448.44 259.2L373.74 216.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 216.07L448.44 259.2L373.74 302.33L299.04 259.2L373.74 216.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M523.14 216.07L448.44 172.94L523.14 129.81L597.84 172.94L523.14 216.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 172.94L373.74 129.81L448.44 86.6799L523.14 129.81L448.44 172.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 86.6901L373.74 129.82L299.04 86.6901L373.74 43.5601L448.44 86.6901Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 216.07L299.04 259.2L224.34 216.07L299.04 172.94L373.74 216.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 259.19L373.74 302.32L299.04 345.45L224.34 302.32L299.04 259.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 86.6901L224.35 43.5601L299.05 86.6901L224.35 129.82L149.65 86.6901V86.6901Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 86.6899L224.35 129.82L149.65 172.95L74.95 129.82L149.65 86.6899V86.6899Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M224.34 129.81L299.04 86.6799L373.74 129.81L299.04 172.94L224.34 129.81V129.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 86.6899L224.34 43.5599L299.04 0.429932L373.74 43.5599L299.04 86.6899Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M224.34 129.81L299.04 172.94L224.34 216.07L149.64 172.94L224.34 129.81V129.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 172.94L224.35 216.07L149.65 259.2L74.95 216.07L149.65 172.94V172.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M74.95 129.81L149.65 172.94L74.95 216.07L0.25 172.94L74.95 129.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 259.19L224.34 302.32L149.64 259.19L224.34 216.06L299.04 259.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M448.44 172.94L373.74 216.07M448.44 259.2L373.74 216.07"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M523.14 216.07L448.44 259.19"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M523.14 216.07L448.44 172.94M448.44 86.6899L373.74 129.82M448.44 172.95L373.74 129.82M523.14 129.82L448.44 172.95"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M523.14 129.81L448.44 86.6799M448.44 259.19L373.74 302.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M373.74 216.07L299.04 259.2M373.74 302.33L299.04 259.2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M597.83 172.94L523.13 216.07M597.83 172.94L523.13 129.81M224.34 43.5601L149.64 86.6901"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M224.34 129.81L149.64 86.68M299.04 86.68L224.34 129.81M299.04 86.68L224.34 43.55M299.04 172.93L224.34 129.8M373.74 129.8L299.04 172.93M373.74 129.8L299.04 86.67M299.04 172.92L224.34 216.05M224.34 129.8L149.64 172.93M224.34 216.06L149.64 172.93"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M149.65 86.6899L74.95 129.81"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M149.65 172.94L74.95 129.81"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M299.04 0.429932L224.34 43.5599"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M373.74 43.5601L299.04 86.6901"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M373.74 43.5599L299.04 0.429932M373.74 302.32L299.04 345.45"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M299.04 259.19L224.34 302.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M299.04 345.45L224.34 302.32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M149.65 172.94L74.95 216.07"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M74.95 129.81L0.25 172.94M74.95 216.07L0.25 172.94"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M224.34 216.07L149.65 259.19"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M149.65 259.19L74.95 216.06M224.35 302.31L149.65 259.18"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M299.04 259.19L224.34 216.07"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2BB1",
    d: "M448.44 86.6901L373.74 43.5601"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2BB1",
    d: "M373.74 216.07L299.04 172.94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_587"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 415,
    width: 598
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/flat.df8a39129779ccf2b8a725653828b462.svg";
export { ForwardRef as ReactComponent };